import $ from 'jquery'

class FullVideo {
	//? 1. describe and create/initiate our object

	constructor() {
		//Verables
		this.events()
	}

	//?events
	events() {
		let myObj = this

		// console.log(window.outerWidth)
		if (window.innerWidth > 992) {
			console.log('use full width')
			myObj.FullVideoFunction()
		} else {
			console.log('use mobile')
			myObj.MobileFrameOne()
			myObj.MobileFrameTwo()
			myObj.MobileFrameThree()
			myObj.FinalFrameVideo()
		}
	}

	//? 3. methods (functions)
	FullVideoFunction() {
		let num = 0

		let activeURL = './wp-content/uploads/FullVideo-slim/laptop_'

		var images = [
			`${activeURL}000.jpg`,
			`${activeURL}001.jpg`,
			`${activeURL}002.jpg`,
			`${activeURL}003.jpg`,
			`${activeURL}004.jpg`,
			`${activeURL}005.jpg`,
			`${activeURL}006.jpg`,
			`${activeURL}007.jpg`,
			`${activeURL}008.jpg`,
			`${activeURL}009.jpg`,
			`${activeURL}010.jpg`,
			`${activeURL}011.jpg`,
			`${activeURL}012.jpg`,
			`${activeURL}013.jpg`,
			`${activeURL}014.jpg`,
			`${activeURL}015.jpg`,
			`${activeURL}016.jpg`,
			`${activeURL}017.jpg`,
			`${activeURL}018.jpg`,
			`${activeURL}019.jpg`,
			`${activeURL}020.jpg`,
			`${activeURL}021.jpg`,
			`${activeURL}022.jpg`,
			`${activeURL}023.jpg`,
			`${activeURL}024.jpg`,
			`${activeURL}025.jpg`,
			`${activeURL}026.jpg`,
			`${activeURL}027.jpg`,
			`${activeURL}028.jpg`,
			`${activeURL}029.jpg`,
			`${activeURL}030.jpg`,
			`${activeURL}031.jpg`,
			`${activeURL}032.jpg`,
			`${activeURL}033.jpg`,
			`${activeURL}034.jpg`,
			`${activeURL}035.jpg`,
			`${activeURL}036.jpg`,
			`${activeURL}037.jpg`,
			`${activeURL}038.jpg`,
			`${activeURL}039.jpg`,
			`${activeURL}040.jpg`,
			`${activeURL}041.jpg`,
			`${activeURL}042.jpg`,
			`${activeURL}043.jpg`,
			`${activeURL}044.jpg`,
			`${activeURL}045.jpg`,
			`${activeURL}046.jpg`,
			`${activeURL}047.jpg`,
			`${activeURL}048.jpg`,
			`${activeURL}049.jpg`,
			`${activeURL}050.jpg`,
			`${activeURL}051.jpg`,
			`${activeURL}052.jpg`,
			`${activeURL}053.jpg`,
			`${activeURL}054.jpg`,
			`${activeURL}055.jpg`,
			`${activeURL}056.jpg`,
			`${activeURL}057.jpg`,
			`${activeURL}058.jpg`,
			`${activeURL}059.jpg`,
			`${activeURL}060.jpg`,
			`${activeURL}061.jpg`,
			`${activeURL}062.jpg`,
			`${activeURL}063.jpg`,
			`${activeURL}064.jpg`,
			`${activeURL}065.jpg`,
			`${activeURL}066.jpg`,
			`${activeURL}067.jpg`,
			`${activeURL}068.jpg`,
			`${activeURL}069.jpg`,
			`${activeURL}070.jpg`,
			`${activeURL}071.jpg`,
			`${activeURL}072.jpg`,
			`${activeURL}073.jpg`,
			`${activeURL}074.jpg`,
			`${activeURL}075.jpg`,
			`${activeURL}076.jpg`,
			`${activeURL}077.jpg`,
			`${activeURL}078.jpg`,
			`${activeURL}079.jpg`,
			`${activeURL}080.jpg`,
			`${activeURL}081.jpg`,
			`${activeURL}082.jpg`,
			`${activeURL}083.jpg`,
			`${activeURL}084.jpg`,
			`${activeURL}085.jpg`,
			`${activeURL}086.jpg`,
			`${activeURL}087.jpg`,
			`${activeURL}088.jpg`,
			`${activeURL}089.jpg`,
			`${activeURL}090.jpg`,
			`${activeURL}091.jpg`,
			`${activeURL}092.jpg`,
			`${activeURL}093.jpg`,
			`${activeURL}094.jpg`,
			`${activeURL}095.jpg`,
			`${activeURL}096.jpg`,
			`${activeURL}097.jpg`,
			`${activeURL}098.jpg`,
			`${activeURL}099.jpg`,
			`${activeURL}100.jpg`,
			`${activeURL}101.jpg`,
			`${activeURL}102.jpg`,
			`${activeURL}103.jpg`,
			`${activeURL}104.jpg`,
			`${activeURL}105.jpg`,
			`${activeURL}106.jpg`,
			`${activeURL}107.jpg`,
			`${activeURL}108.jpg`,
			`${activeURL}109.jpg`,
			`${activeURL}110.jpg`,
			`${activeURL}111.jpg`,
			`${activeURL}112.jpg`,
			`${activeURL}113.jpg`,
			`${activeURL}114.jpg`,
			`${activeURL}115.jpg`,
			`${activeURL}116.jpg`,
			`${activeURL}117.jpg`,
			`${activeURL}118.jpg`,
			`${activeURL}119.jpg`,
			`${activeURL}120.jpg`,
			`${activeURL}121.jpg`,
			`${activeURL}122.jpg`,
			`${activeURL}123.jpg`,
			`${activeURL}124.jpg`,
			`${activeURL}125.jpg`,
			`${activeURL}126.jpg`,
			`${activeURL}127.jpg`,
			`${activeURL}128.jpg`,
			`${activeURL}129.jpg`,
			`${activeURL}130.jpg`,
			`${activeURL}131.jpg`,
			`${activeURL}132.jpg`,
			`${activeURL}133.jpg`,
			`${activeURL}134.jpg`,
			`${activeURL}135.jpg`,
			`${activeURL}136.jpg`,
			`${activeURL}137.jpg`,
			`${activeURL}138.jpg`,
			`${activeURL}139.jpg`,
			`${activeURL}140.jpg`,
			`${activeURL}141.jpg`,
			`${activeURL}142.jpg`,
			`${activeURL}143.jpg`,
			`${activeURL}144.jpg`,
			`${activeURL}145.jpg`,
			`${activeURL}146.jpg`,
			`${activeURL}147.jpg`,
			`${activeURL}148.jpg`,
			`${activeURL}149.jpg`,
			`${activeURL}150.jpg`,
			`${activeURL}151.jpg`,
			`${activeURL}152.jpg`,
			`${activeURL}153.jpg`,
			`${activeURL}154.jpg`,
			`${activeURL}155.jpg`,
			`${activeURL}156.jpg`,
			`${activeURL}157.jpg`,
			`${activeURL}158.jpg`,
			`${activeURL}159.jpg`,
			`${activeURL}160.jpg`,
			`${activeURL}161.jpg`,
			`${activeURL}162.jpg`,
			`${activeURL}163.jpg`,
			`${activeURL}164.jpg`,
			`${activeURL}165.jpg`,
			`${activeURL}166.jpg`,
			`${activeURL}167.jpg`,
			`${activeURL}168.jpg`,
			`${activeURL}169.jpg`,
			`${activeURL}170.jpg`,
			`${activeURL}171.jpg`,
			`${activeURL}172.jpg`,
			`${activeURL}173.jpg`,
			`${activeURL}174.jpg`,
			`${activeURL}175.jpg`,
			`${activeURL}176.jpg`,
			`${activeURL}177.jpg`,
			`${activeURL}178.jpg`,
			`${activeURL}179.jpg`,
			`${activeURL}180.jpg`,
			`${activeURL}181.jpg`,
			`${activeURL}182.jpg`,
			`${activeURL}183.jpg`,
			`${activeURL}184.jpg`,
			`${activeURL}185.jpg`,
			`${activeURL}186.jpg`,
			`${activeURL}187.jpg`,
			`${activeURL}188.jpg`,
			`${activeURL}189.jpg`,
			`${activeURL}190.jpg`,
			`${activeURL}191.jpg`,
			`${activeURL}192.jpg`,
			`${activeURL}193.jpg`,
			`${activeURL}194.jpg`,
			`${activeURL}195.jpg`,
			`${activeURL}196.jpg`,
			`${activeURL}197.jpg`,
			`${activeURL}198.jpg`,
			`${activeURL}199.jpg`,
			`${activeURL}200.jpg`,
			`${activeURL}201.jpg`,
			`${activeURL}202.jpg`,
			`${activeURL}203.jpg`,
			`${activeURL}204.jpg`,
			`${activeURL}205.jpg`,
			`${activeURL}206.jpg`,
			`${activeURL}207.jpg`,
			`${activeURL}208.jpg`,
			`${activeURL}209.jpg`,
			`${activeURL}210.jpg`,
			`${activeURL}211.jpg`,
			`${activeURL}212.jpg`,
			`${activeURL}213.jpg`,
			`${activeURL}214.jpg`,
			`${activeURL}215.jpg`,
			`${activeURL}216.jpg`,
			`${activeURL}217.jpg`,
			`${activeURL}218.jpg`,
			`${activeURL}219.jpg`,
			`${activeURL}220.jpg`,
			`${activeURL}221.jpg`,
			`${activeURL}222.jpg`,
			`${activeURL}223.jpg`,
			`${activeURL}224.jpg`,
			`${activeURL}225.jpg`,
			`${activeURL}226.jpg`,
			`${activeURL}227.jpg`,
			`${activeURL}228.jpg`,
			`${activeURL}229.jpg`,
			`${activeURL}230.jpg`,
			`${activeURL}231.jpg`,
			`${activeURL}232.jpg`,
			`${activeURL}233.jpg`,
			`${activeURL}234.jpg`,
			`${activeURL}235.jpg`,
			`${activeURL}236.jpg`,
			`${activeURL}237.jpg`,
			`${activeURL}238.jpg`,
			`${activeURL}239.jpg`,
			`${activeURL}240.jpg`,
			`${activeURL}241.jpg`,
			`${activeURL}242.jpg`,
			`${activeURL}243.jpg`,
			`${activeURL}244.jpg`,
			`${activeURL}245.jpg`,
			`${activeURL}246.jpg`,
			`${activeURL}247.jpg`,
			`${activeURL}248.jpg`,
			`${activeURL}249.jpg`,
			`${activeURL}250.jpg`,
			`${activeURL}251.jpg`,
			`${activeURL}252.jpg`,
			`${activeURL}253.jpg`,
			`${activeURL}254.jpg`,
			`${activeURL}255.jpg`,
			`${activeURL}256.jpg`,
			`${activeURL}257.jpg`,
			`${activeURL}258.jpg`,
			`${activeURL}259.jpg`,
			`${activeURL}260.jpg`,
			`${activeURL}261.jpg`,
			`${activeURL}262.jpg`,
			`${activeURL}263.jpg`,
			`${activeURL}264.jpg`,
			`${activeURL}265.jpg`,
			`${activeURL}266.jpg`,
			`${activeURL}267.jpg`,
			`${activeURL}268.jpg`,
			`${activeURL}269.jpg`,
			`${activeURL}270.jpg`,
			`${activeURL}271.jpg`,
			`${activeURL}272.jpg`,
			`${activeURL}273.jpg`,
			`${activeURL}274.jpg`,
			`${activeURL}275.jpg`,
			`${activeURL}276.jpg`,
			`${activeURL}277.jpg`,
			`${activeURL}278.jpg`,
			`${activeURL}279.jpg`,
			`${activeURL}280.jpg`,
			`${activeURL}281.jpg`,
			`${activeURL}282.jpg`,
			`${activeURL}283.jpg`,
			`${activeURL}284.jpg`,
			`${activeURL}285.jpg`,
			`${activeURL}286.jpg`,
			`${activeURL}287.jpg`,
			`${activeURL}288.jpg`,
			`${activeURL}289.jpg`,
			`${activeURL}290.jpg`,
			`${activeURL}291.jpg`,
			`${activeURL}292.jpg`,
			`${activeURL}293.jpg`,
			`${activeURL}294.jpg`,
			`${activeURL}295.jpg`,
			`${activeURL}296.jpg`,
			`${activeURL}297.jpg`,
			`${activeURL}298.jpg`,
			`${activeURL}299.jpg`,
			`${activeURL}300.jpg`,
			`${activeURL}301.jpg`,
			`${activeURL}302.jpg`,
			`${activeURL}303.jpg`,
			`${activeURL}304.jpg`,
			`${activeURL}305.jpg`,
			`${activeURL}306.jpg`,
			`${activeURL}307.jpg`,
			`${activeURL}308.jpg`,
			`${activeURL}309.jpg`,
			`${activeURL}310.jpg`,
			`${activeURL}311.jpg`,
			`${activeURL}312.jpg`,
			`${activeURL}313.jpg`,
			`${activeURL}313.jpg`,
			`${activeURL}314.jpg`,
			`${activeURL}315.jpg`,
			`${activeURL}316.jpg`,
			`${activeURL}317.jpg`,
			`${activeURL}318.jpg`,
			`${activeURL}319.jpg`,
			`${activeURL}320.jpg`,
			`${activeURL}321.jpg`,
			`${activeURL}322.jpg`,
			`${activeURL}323.jpg`,
			`${activeURL}324.jpg`,
			`${activeURL}325.jpg`,
			`${activeURL}326.jpg`,
			`${activeURL}327.jpg`,
			`${activeURL}328.jpg`,
			`${activeURL}329.jpg`,
			`${activeURL}330.jpg`,
			`${activeURL}331.jpg`,
			`${activeURL}332.jpg`,
			`${activeURL}333.jpg`,
			`${activeURL}334.jpg`,
			`${activeURL}335.jpg`,
			`${activeURL}336.jpg`,
			`${activeURL}337.jpg`,
			`${activeURL}338.jpg`,
			`${activeURL}339.jpg`,
			`${activeURL}340.jpg`,
			`${activeURL}341.jpg`,
			`${activeURL}342.jpg`,
			`${activeURL}343.jpg`,
			`${activeURL}344.jpg`,
			`${activeURL}345.jpg`,
			`${activeURL}346.jpg`,
			`${activeURL}347.jpg`,
			`${activeURL}348.jpg`,
			`${activeURL}349.jpg`,
			`${activeURL}350.jpg`,
			`${activeURL}351.jpg`,
			`${activeURL}352.jpg`,
			`${activeURL}353.jpg`,
			`${activeURL}354.jpg`,
			`${activeURL}355.jpg`,
			`${activeURL}356.jpg`,
			`${activeURL}357.jpg`,
			`${activeURL}358.jpg`,
			`${activeURL}359.jpg`,
			`${activeURL}360.jpg`,
			`${activeURL}361.jpg`,
			`${activeURL}362.jpg`,
			`${activeURL}363.jpg`,
			`${activeURL}364.jpg`,
			`${activeURL}365.jpg`,
			`${activeURL}366.jpg`,
			`${activeURL}367.jpg`,
			`${activeURL}368.jpg`,
			`${activeURL}369.jpg`,
			`${activeURL}370.jpg`,
			`${activeURL}371.jpg`,
			`${activeURL}372.jpg`,
			`${activeURL}373.jpg`,
			`${activeURL}374.jpg`,
			`${activeURL}375.jpg`,
			`${activeURL}376.jpg`,
			`${activeURL}377.jpg`,
			`${activeURL}378.jpg`,
			`${activeURL}379.jpg`,
			`${activeURL}380.jpg`,
			`${activeURL}381.jpg`,
			`${activeURL}382.jpg`,
			`${activeURL}383.jpg`,
			`${activeURL}384.jpg`,
			`${activeURL}385.jpg`,
			`${activeURL}386.jpg`,
			`${activeURL}387.jpg`,
			`${activeURL}388.jpg`,
			`${activeURL}389.jpg`,
			`${activeURL}390.jpg`,
			`${activeURL}391.jpg`,
			`${activeURL}392.jpg`,
			`${activeURL}393.jpg`,
			`${activeURL}394.jpg`,
			`${activeURL}395.jpg`,
			`${activeURL}396.jpg`,
			`${activeURL}397.jpg`,
			`${activeURL}398.jpg`,
			`${activeURL}399.jpg`,
			`${activeURL}400.jpg`,
			`${activeURL}401.jpg`,
			`${activeURL}402.jpg`,
			`${activeURL}403.jpg`,
			`${activeURL}404.jpg`,
			`${activeURL}405.jpg`,
			`${activeURL}406.jpg`,
			`${activeURL}407.jpg`,
			`${activeURL}408.jpg`,
			`${activeURL}409.jpg`,
			`${activeURL}410.jpg`,
			`${activeURL}411.jpg`,
			`${activeURL}412.jpg`,
			`${activeURL}413.jpg`,
			`${activeURL}414.jpg`,
			`${activeURL}415.jpg`,
			`${activeURL}416.jpg`,
			`${activeURL}417.jpg`,
			`${activeURL}418.jpg`,
			`${activeURL}419.jpg`,
			`${activeURL}420.jpg`,
			`${activeURL}421.jpg`,
			`${activeURL}422.jpg`,
			`${activeURL}423.jpg`,
			`${activeURL}424.jpg`,
			`${activeURL}425.jpg`,
			`${activeURL}426.jpg`,
			`${activeURL}427.jpg`,
			`${activeURL}428.jpg`,
			`${activeURL}429.jpg`,
			`${activeURL}430.jpg`,
			`${activeURL}431.jpg`,
			`${activeURL}432.jpg`,
			`${activeURL}433.jpg`,
			`${activeURL}434.jpg`,
			`${activeURL}435.jpg`,
			`${activeURL}436.jpg`,
			`${activeURL}437.jpg`,
			`${activeURL}438.jpg`,
			`${activeURL}439.jpg`,
			`${activeURL}440.jpg`,
			`${activeURL}441.jpg`,
			`${activeURL}442.jpg`,
			`${activeURL}443.jpg`,
			`${activeURL}444.jpg`,
			`${activeURL}445.jpg`,
			`${activeURL}446.jpg`,
			`${activeURL}447.jpg`,
			`${activeURL}448.jpg`,
			`${activeURL}449.jpg`,
			`${activeURL}450.jpg`,
			`${activeURL}451.jpg`,
			`${activeURL}452.jpg`,
			`${activeURL}453.jpg`,
			`${activeURL}454.jpg`,
			`${activeURL}455.jpg`,
			`${activeURL}456.jpg`,
			`${activeURL}457.jpg`,
			`${activeURL}458.jpg`,
			`${activeURL}459.jpg`,
			`${activeURL}460.jpg`,
			`${activeURL}461.jpg`,
			`${activeURL}462.jpg`,
			`${activeURL}463.jpg`,
			`${activeURL}464.jpg`,
			`${activeURL}465.jpg`,
			`${activeURL}466.jpg`,
			`${activeURL}467.jpg`,
			`${activeURL}468.jpg`,
			`${activeURL}469.jpg`,
			`${activeURL}470.jpg`,
			`${activeURL}471.jpg`,
			`${activeURL}472.jpg`,
			`${activeURL}473.jpg`,
			`${activeURL}474.jpg`,
			`${activeURL}475.jpg`,
		]

		function preloadImages(images) {
			for (let i = 0; i < images.length; i++) {
				let l = document.createElement('link')
				l.rel = 'preload'
				l.as = 'image'
				l.href = images[i]
				document.head.appendChild(l)
			}
		}

		preloadImages(images)

		// console.log(images);
		var obj = { curImg: 0 }

		// create tween

		let fullVid = new TimelineMax()

		// apiTL.from('.copy-container', 3, { opacity: 0 })
		fullVid
			.add('start', 0)
			.add('video', 1)
			.add('frameTwo', 3.3)
			.add('frameThree', 7.6)
			.add('FinalFrame', 9.8)
			.to(
				obj,
				10,
				{
					curImg: images.length - 1, // animate propery curImg to number of images
					roundProps: 'curImg', // only integers so it can be used as an array index
					// repeat: 0, // repeat 3 times
					immediateRender: true, // load first image automatically
					ease: Linear.easeNone, // show every image the same ammount of time
					onUpdate: function () {
						$('.fullVideo-imgSequence').attr('src', images[obj.curImg]) // set the image source
					},
				},
				'video'
			)
			// .from('.frameFrame-copy ', 1, { y: 100, opacity: 0 }, 'start')
			.to(
				'.frameFrame-copy ',
				0.2,
				{ y: -150, opacity: 0, delay: 1.8 },
				'video'
			)
			.staggerFrom(
				'.content-row-adnimate',
				0.3,
				{ y: 100, opacity: 0 },
				0.2,
				'frameTwo'
			)
			.staggerTo(
				'.content-row-adnimate',
				0.2,
				{ y: -100, opacity: 0, delay: 2.5 },
				0.1,
				'frameTwo'
			)
			.staggerFrom(
				'.content-two-animate',
				0.15,
				{ y: 100, opacity: 0 },
				0.05,
				'frameThree'
			)
			.staggerTo(
				'.content-two-animate',
				0.2,
				{ y: -100, opacity: 0, delay: 2.5, delay: 1.2 },
				0.1,
				'frameThree'
			)
			.staggerFrom(
				'.lastFrame-copy',
				0.15,
				{ y: 80, opacity: 0, delay: 0.8 },
				0.05,
				'FinalFrame'
			)
			.to('.fullVideo-imgSequence', 0.5, { opacity: 1 })

		let offSetNum = window.innerHeight / 2
		var controller = new ScrollMagic.Controller()

		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '#fullVideo',
			offset: window.innerHeight / 2,
			duration: 7000,
		})
			// .addIndicators({
			// 	name: ' cans',
			// 	colorTrigger: 'red',
			// 	colorStart: 'red',
			// 	colorEnd: 'red',
			// 	indent: 200,
			// })
			// .setTween(tween)
			.setTween(fullVid)
			.setPin('#fullVideo')
			.addTo(controller)
	}

	MobileFrameOne() {
		let num = 0

		let activeURL = './wp-content/uploads/frameOne/MobileComp'

		var images = [
			`${activeURL}014.jpg`,
			`${activeURL}015.jpg`,
			`${activeURL}016.jpg`,
			`${activeURL}017.jpg`,
			`${activeURL}018.jpg`,
			`${activeURL}019.jpg`,
			`${activeURL}020.jpg`,
			`${activeURL}021.jpg`,
			`${activeURL}022.jpg`,
			`${activeURL}023.jpg`,
			`${activeURL}024.jpg`,
			`${activeURL}025.jpg`,
			`${activeURL}026.jpg`,
			`${activeURL}027.jpg`,
			`${activeURL}028.jpg`,
			`${activeURL}029.jpg`,
			`${activeURL}030.jpg`,
			`${activeURL}031.jpg`,
			`${activeURL}032.jpg`,
			`${activeURL}033.jpg`,
			`${activeURL}034.jpg`,
			`${activeURL}035.jpg`,
			`${activeURL}036.jpg`,
			`${activeURL}037.jpg`,
			`${activeURL}038.jpg`,
			`${activeURL}039.jpg`,
			`${activeURL}040.jpg`,
			`${activeURL}041.jpg`,
			`${activeURL}042.jpg`,
			`${activeURL}043.jpg`,
			`${activeURL}044.jpg`,
			`${activeURL}045.jpg`,
			`${activeURL}046.jpg`,
			`${activeURL}047.jpg`,
			`${activeURL}048.jpg`,
			`${activeURL}049.jpg`,
			`${activeURL}050.jpg`,
			`${activeURL}051.jpg`,
			`${activeURL}052.jpg`,
			`${activeURL}053.jpg`,
			`${activeURL}054.jpg`,
			`${activeURL}055.jpg`,
			`${activeURL}056.jpg`,
			`${activeURL}057.jpg`,
			`${activeURL}058.jpg`,
			`${activeURL}059.jpg`,
			`${activeURL}060.jpg`,
			`${activeURL}061.jpg`,
			`${activeURL}062.jpg`,
			`${activeURL}063.jpg`,
			`${activeURL}064.jpg`,
			`${activeURL}065.jpg`,
			`${activeURL}066.jpg`,
			`${activeURL}067.jpg`,
			`${activeURL}068.jpg`,
			`${activeURL}069.jpg`,
			`${activeURL}070.jpg`,
			`${activeURL}071.jpg`,
			`${activeURL}072.jpg`,
			`${activeURL}073.jpg`,
			`${activeURL}074.jpg`,
			`${activeURL}075.jpg`,
			`${activeURL}076.jpg`,
			`${activeURL}077.jpg`,
			`${activeURL}078.jpg`,
			`${activeURL}079.jpg`,
			`${activeURL}080.jpg`,
			`${activeURL}081.jpg`,
			`${activeURL}082.jpg`,
			`${activeURL}083.jpg`,
			`${activeURL}084.jpg`,
			`${activeURL}085.jpg`,
		]

		function preloadImages(images) {
			for (let i = 0; i < images.length; i++) {
				let l = document.createElement('link')
				l.rel = 'preload'
				l.as = 'image'
				l.href = images[i]
				document.head.appendChild(l)
			}
		}

		preloadImages(images)

		// console.log(images);
		var obj = { curImg: 0 }

		// create tween

		let FirstFram = new TimelineMax()

		// apiTL.from('.copy-container', 3, { opacity: 0 })
		FirstFram.add('start', 0)
			.add('video', 1)
			.add('frameTwo', 3.3)
			.add('frameThree', 7.5)
			.add('FinalFrame', 9)
			.to(
				obj,
				10,
				{
					curImg: images.length - 1, // animate propery curImg to number of images
					roundProps: 'curImg', // only integers so it can be used as an array index
					// repeat: 0, // repeat 3 times
					immediateRender: true, // load first image automatically
					ease: Linear.easeNone, // show every image the same ammount of time
					onUpdate: function () {
						$('.frameOneVideo').attr('src', images[obj.curImg]) // set the image source
					},
				},
				'video'
			)

		let offSetNum = window.innerHeight / 2
		var controller = new ScrollMagic.Controller()

		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '.frameOneVideo',
			offset: -300,
			duration: 500,
		})
			// .addIndicators({
			// 	name: ' cans',
			// 	colorTrigger: 'red',
			// 	colorStart: 'red',
			// 	colorEnd: 'red',
			// 	indent: 200,
			// })
			// .setTween(tween)
			.setTween(FirstFram)
			// .setPin('#fullVideo')
			.addTo(controller)
	}

	MobileFrameTwo() {
		let num = 0

		let activeURL = './wp-content/uploads/FrameThree/mobileFrameThree'

		var images = [
			`${activeURL}010.jpg`,
			`${activeURL}011.jpg`,
			`${activeURL}012.jpg`,
			`${activeURL}013.jpg`,
			`${activeURL}014.jpg`,
			`${activeURL}015.jpg`,
			`${activeURL}016.jpg`,
			`${activeURL}017.jpg`,
			`${activeURL}018.jpg`,
			`${activeURL}019.jpg`,
			`${activeURL}020.jpg`,
			`${activeURL}021.jpg`,
			`${activeURL}022.jpg`,
			`${activeURL}023.jpg`,
			`${activeURL}024.jpg`,
			`${activeURL}025.jpg`,
			`${activeURL}026.jpg`,
			`${activeURL}027.jpg`,
			`${activeURL}028.jpg`,
			`${activeURL}029.jpg`,
			`${activeURL}030.jpg`,
			`${activeURL}031.jpg`,
			`${activeURL}032.jpg`,
			`${activeURL}033.jpg`,
			`${activeURL}034.jpg`,
			`${activeURL}035.jpg`,
			`${activeURL}036.jpg`,
			`${activeURL}037.jpg`,
			`${activeURL}038.jpg`,
			`${activeURL}039.jpg`,
			`${activeURL}040.jpg`,
			`${activeURL}041.jpg`,
			`${activeURL}042.jpg`,
			`${activeURL}043.jpg`,
			`${activeURL}044.jpg`,
			`${activeURL}045.jpg`,
			`${activeURL}046.jpg`,
			`${activeURL}047.jpg`,
			`${activeURL}048.jpg`,
			`${activeURL}049.jpg`,
			`${activeURL}050.jpg`,
			`${activeURL}051.jpg`,
			`${activeURL}052.jpg`,
			`${activeURL}053.jpg`,
			`${activeURL}054.jpg`,
			`${activeURL}055.jpg`,
			`${activeURL}056.jpg`,
			`${activeURL}057.jpg`,
			`${activeURL}058.jpg`,
			`${activeURL}059.jpg`,
			`${activeURL}060.jpg`,
			`${activeURL}061.jpg`,
			`${activeURL}062.jpg`,
			`${activeURL}063.jpg`,
			`${activeURL}064.jpg`,
			`${activeURL}065.jpg`,
			`${activeURL}066.jpg`,
			`${activeURL}067.jpg`,
			`${activeURL}068.jpg`,
			`${activeURL}069.jpg`,
			`${activeURL}070.jpg`,
			`${activeURL}071.jpg`,
			`${activeURL}072.jpg`,
			`${activeURL}073.jpg`,
			`${activeURL}074.jpg`,
			`${activeURL}075.jpg`,
			`${activeURL}076.jpg`,
			`${activeURL}077.jpg`,
			`${activeURL}078.jpg`,
			`${activeURL}079.jpg`,
			`${activeURL}080.jpg`,
			`${activeURL}081.jpg`,
			`${activeURL}082.jpg`,
			`${activeURL}083.jpg`,
			`${activeURL}084.jpg`,
			`${activeURL}085.jpg`,
			`${activeURL}086.jpg`,
			`${activeURL}087.jpg`,
			`${activeURL}088.jpg`,
			`${activeURL}089.jpg`,
			`${activeURL}090.jpg`,
			`${activeURL}091.jpg`,
			`${activeURL}092.jpg`,
			`${activeURL}093.jpg`,
			`${activeURL}094.jpg`,
			`${activeURL}095.jpg`,
			`${activeURL}096.jpg`,
			`${activeURL}097.jpg`,
			`${activeURL}098.jpg`,
			`${activeURL}099.jpg`,
			`${activeURL}100.jpg`,
			`${activeURL}101.jpg`,
			`${activeURL}102.jpg`,
			`${activeURL}103.jpg`,
			`${activeURL}104.jpg`,
			`${activeURL}105.jpg`,
			`${activeURL}106.jpg`,
			`${activeURL}107.jpg`,
			`${activeURL}108.jpg`,
			`${activeURL}109.jpg`,
			`${activeURL}110.jpg`,
			`${activeURL}111.jpg`,
			`${activeURL}112.jpg`,
			`${activeURL}113.jpg`,
			`${activeURL}114.jpg`,
			`${activeURL}115.jpg`,
			`${activeURL}116.jpg`,
			`${activeURL}117.jpg`,
			`${activeURL}118.jpg`,
			`${activeURL}119.jpg`,
			`${activeURL}120.jpg`,
			`${activeURL}121.jpg`,
			`${activeURL}122.jpg`,
			`${activeURL}123.jpg`,
			`${activeURL}124.jpg`,
			`${activeURL}125.jpg`,
			`${activeURL}126.jpg`,
			`${activeURL}127.jpg`,
			`${activeURL}128.jpg`,
			`${activeURL}129.jpg`,
			`${activeURL}130.jpg`,
			`${activeURL}131.jpg`,
			`${activeURL}132.jpg`,
			`${activeURL}133.jpg`,
			`${activeURL}134.jpg`,
			`${activeURL}135.jpg`,
			`${activeURL}136.jpg`,
			`${activeURL}137.jpg`,
			`${activeURL}138.jpg`,
			`${activeURL}139.jpg`,
			`${activeURL}140.jpg`,
			`${activeURL}141.jpg`,
			`${activeURL}142.jpg`,
			`${activeURL}143.jpg`,
			`${activeURL}144.jpg`,
			`${activeURL}145.jpg`,
			`${activeURL}146.jpg`,
			`${activeURL}147.jpg`,
			`${activeURL}148.jpg`,
			`${activeURL}149.jpg`,
			`${activeURL}150.jpg`,
			`${activeURL}151.jpg`,
			`${activeURL}152.jpg`,
			`${activeURL}153.jpg`,
			`${activeURL}154.jpg`,
			`${activeURL}155.jpg`,
		]

		function preloadImages(images) {
			for (let i = 0; i < images.length; i++) {
				let l = document.createElement('link')
				l.rel = 'preload'
				l.as = 'image'
				l.href = images[i]
				document.head.appendChild(l)
			}
		}

		preloadImages(images)

		// console.log(images);
		var obj = { curImg: 0 }

		// create tween

		let FirstFram = new TimelineMax()

		// apiTL.from('.copy-container', 3, { opacity: 0 })
		FirstFram.add('start', 0)
			.add('video', 1)
			.add('frameTwo', 3.3)
			.add('frameThree', 7.5)
			.add('FinalFrame', 9)
			.to(
				obj,
				10,
				{
					curImg: images.length - 1, // animate propery curImg to number of images
					roundProps: 'curImg', // only integers so it can be used as an array index
					// repeat: 0, // repeat 3 times
					immediateRender: true, // load first image automatically
					ease: Linear.easeNone, // show every image the same ammount of time
					onUpdate: function () {
						$('.frameTwoVideo').attr('src', images[obj.curImg]) // set the image source
					},
				},
				'video'
			)

		let offSetNum = window.innerHeight / 2
		var controller = new ScrollMagic.Controller()

		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '.frameTwoVideo',
			offset: -100,
			duration: 500,
		})
			// .addIndicators({
			// 	name: ' cans',
			// 	colorTrigger: 'red',
			// 	colorStart: 'red',
			// 	colorEnd: 'red',
			// 	indent: 200,
			// })
			// .setTween(tween)
			.setTween(FirstFram)
			// .setPin('#fullVideo')
			.addTo(controller)
	}

	MobileFrameThree() {
		let num = 0

		let activeURL = './wp-content/uploads/frameTwo/mobileFrameTwo'

		var images = [
			`${activeURL}00.jpg`,
			`${activeURL}01.jpg`,
			`${activeURL}02.jpg`,
			`${activeURL}03.jpg`,
			`${activeURL}04.jpg`,
			`${activeURL}05.jpg`,
			`${activeURL}06.jpg`,
			`${activeURL}07.jpg`,
			`${activeURL}08.jpg`,
			`${activeURL}09.jpg`,
			`${activeURL}10.jpg`,
			`${activeURL}11.jpg`,
			`${activeURL}12.jpg`,
			`${activeURL}13.jpg`,
			`${activeURL}14.jpg`,
			`${activeURL}15.jpg`,
			`${activeURL}16.jpg`,
			`${activeURL}17.jpg`,
			`${activeURL}18.jpg`,
			`${activeURL}19.jpg`,
			`${activeURL}20.jpg`,
			`${activeURL}21.jpg`,
			`${activeURL}22.jpg`,
			`${activeURL}23.jpg`,
			`${activeURL}24.jpg`,
			`${activeURL}25.jpg`,
			`${activeURL}26.jpg`,
			`${activeURL}27.jpg`,
			`${activeURL}28.jpg`,
			`${activeURL}29.jpg`,
			`${activeURL}30.jpg`,
		]

		function preloadImages(images) {
			for (let i = 0; i < images.length; i++) {
				let l = document.createElement('link')
				l.rel = 'preload'
				l.as = 'image'
				l.href = images[i]
				document.head.appendChild(l)
			}
		}

		preloadImages(images)

		// console.log(images);
		var obj = { curImg: 0 }

		// create tween

		let FirstFram = new TimelineMax()

		// apiTL.from('.copy-container', 3, { opacity: 0 })
		FirstFram.add('start', 0)
			.add('video', 1)
			.add('frameTwo', 3.3)
			.add('frameThree', 7.5)
			.add('FinalFrame', 9)
			.to(
				obj,
				10,
				{
					curImg: images.length - 1, // animate propery curImg to number of images
					roundProps: 'curImg', // only integers so it can be used as an array index
					// repeat: 0, // repeat 3 times
					immediateRender: true, // load first image automatically
					ease: Linear.easeNone, // show every image the same ammount of time
					onUpdate: function () {
						$('.frameThreeVideo').attr('src', images[obj.curImg]) // set the image source
					},
				},
				'video'
			)

		let offSetNum = window.innerHeight / 2
		var controller = new ScrollMagic.Controller()

		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '.frameThreeVideo',
			offset: -250,
			duration: 500,
		})
			// .addIndicators({
			// 	name: ' cans',
			// 	colorTrigger: 'red',
			// 	colorStart: 'red',
			// 	colorEnd: 'red',
			// 	indent: 200,
			// })
			// .setTween(tween)
			.setTween(FirstFram)
			// .setPin('#fullVideo')
			.addTo(controller)
	}

	FinalFrameVideo() {
		let num = 0

		let activeURL = './wp-content/uploads/FinalFrame/mobileFinal'

		var images = [
			`${activeURL}00.jpg`,
			`${activeURL}01.jpg`,
			`${activeURL}02.jpg`,
			`${activeURL}03.jpg`,
			`${activeURL}04.jpg`,
			`${activeURL}05.jpg`,
			`${activeURL}06.jpg`,
			`${activeURL}07.jpg`,
			`${activeURL}08.jpg`,
			`${activeURL}09.jpg`,
			`${activeURL}10.jpg`,
			`${activeURL}11.jpg`,
			`${activeURL}12.jpg`,
			`${activeURL}13.jpg`,
			`${activeURL}14.jpg`,
			`${activeURL}15.jpg`,
			`${activeURL}16.jpg`,
			`${activeURL}17.jpg`,
			`${activeURL}18.jpg`,
			`${activeURL}19.jpg`,
			`${activeURL}20.jpg`,
			`${activeURL}21.jpg`,
			`${activeURL}22.jpg`,
			`${activeURL}23.jpg`,
			`${activeURL}24.jpg`,
			`${activeURL}25.jpg`,
			`${activeURL}26.jpg`,
			`${activeURL}27.jpg`,
			`${activeURL}28.jpg`,
			`${activeURL}29.jpg`,
			`${activeURL}30.jpg`,
			`${activeURL}31.jpg`,
			`${activeURL}32.jpg`,
			`${activeURL}33.jpg`,
			`${activeURL}34.jpg`,
			`${activeURL}35.jpg`,
			`${activeURL}36.jpg`,
			`${activeURL}37.jpg`,
			`${activeURL}38.jpg`,
			`${activeURL}39.jpg`,
			`${activeURL}40.jpg`,
			`${activeURL}41.jpg`,
			`${activeURL}42.jpg`,
			`${activeURL}43.jpg`,
			`${activeURL}44.jpg`,
			`${activeURL}45.jpg`,
			`${activeURL}46.jpg`,
			`${activeURL}47.jpg`,
			`${activeURL}48.jpg`,
			`${activeURL}49.jpg`,
			`${activeURL}50.jpg`,
			`${activeURL}51.jpg`,
			`${activeURL}52.jpg`,
			`${activeURL}53.jpg`,
			`${activeURL}54.jpg`,
			`${activeURL}55.jpg`,
			`${activeURL}56.jpg`,
			`${activeURL}57.jpg`,
			`${activeURL}58.jpg`,
			`${activeURL}59.jpg`,
			`${activeURL}60.jpg`,
			`${activeURL}61.jpg`,
			`${activeURL}62.jpg`,
			`${activeURL}63.jpg`,
			`${activeURL}64.jpg`,
			`${activeURL}65.jpg`,
			`${activeURL}66.jpg`,
			`${activeURL}67.jpg`,
			`${activeURL}68.jpg`,
			`${activeURL}69.jpg`,
			`${activeURL}70.jpg`,
			`${activeURL}71.jpg`,
			`${activeURL}72.jpg`,
			`${activeURL}73.jpg`,
			`${activeURL}74.jpg`,
			`${activeURL}75.jpg`,
			`${activeURL}76.jpg`,
			`${activeURL}77.jpg`,
			`${activeURL}78.jpg`,
			`${activeURL}79.jpg`,
			`${activeURL}80.jpg`,
			`${activeURL}81.jpg`,
			`${activeURL}82.jpg`,
			`${activeURL}83.jpg`,
			`${activeURL}84.jpg`,
			`${activeURL}85.jpg`,
		]

		function preloadImages(images) {
			for (let i = 0; i < images.length; i++) {
				let l = document.createElement('link')
				l.rel = 'preload'
				l.as = 'image'
				l.href = images[i]
				document.head.appendChild(l)
			}
		}

		preloadImages(images)

		// console.log(images);
		var obj = { curImg: 0 }

		// create tween

		let FirstFram = new TimelineMax()

		// apiTL.from('.copy-container', 3, { opacity: 0 })
		FirstFram.add('start', 0)
			.add('video', 1)
			.add('frameTwo', 3.3)
			.add('frameThree', 7.5)
			.add('FinalFrame', 9)
			.to(
				obj,
				10,
				{
					curImg: images.length - 1, // animate propery curImg to number of images
					roundProps: 'curImg', // only integers so it can be used as an array index
					// repeat: 0, // repeat 3 times
					immediateRender: true, // load first image automatically
					ease: Linear.easeNone, // show every image the same ammount of time
					onUpdate: function () {
						$('.FinalFrameVideo').attr('src', images[obj.curImg]) // set the image source
					},
				},
				'video'
			)

		let offSetNum = window.innerHeight / 2
		var controller = new ScrollMagic.Controller()

		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '.FinalFrameVideo',
			offset: -250,
			duration: 500,
		})
			// .addIndicators({
			// 	name: ' cans',
			// 	colorTrigger: 'red',
			// 	colorStart: 'red',
			// 	colorEnd: 'red',
			// 	indent: 200,
			// })
			// .setTween(tween)
			.setTween(FirstFram)
			// .setPin('#fullVideo')
			.addTo(controller)
	}
}

export default FullVideo
